import React, { memo } from "react";
import { Modal, Button } from 'antd';
import s from "./confirm.module.less";

const Confirm = (props) => {
    const { width, title, content, cancelBtnText, okBtnText, open, onClose, onCancel, onConfirm } = props;

    return (
        <Modal
            className={s.confirmModal}
            open={open}
            width={width || 545}
            title={title || '提示'}
            onCancel={() => onClose()}
            footer={
                <>
                    <Button onClick={() => onCancel()} className="circleBtnGray">{cancelBtnText}</Button>
                    <Button type="primary" className="circleBtn" onClick={() => onConfirm()}>{okBtnText}</Button>
                </>
            }
        >
            <div>{content}</div>
        </Modal>
    )
}

export default memo(Confirm);